import { useParams, useSearchParams } from 'react-router-dom'

import { PresenterScreen } from '../components/Presenter/PresenterScreen'
import { PrintDeck } from '../components/Presenter/PrintDeck'

/**
 * A public share link (MYD-509): `/share/presentation/:token`.
 *
 * The same presenter as inside the app (the full-screen presenter on a
 * computer, the touch viewer on a tablet), fed from the link's snapshot
 * instead of the live deck, and signed out. No app chrome: the presenter
 * covers the page, and its screens carry a small "Shared with MyDealTeams".
 *
 * A route of the app, though it sits under the server's `/share` prefix:
 * see backend/utilities/serverOwnedPaths.js.
 */
export function PublicPresentationScreen() {
	const { token = '' } = useParams()
	const [params] = useSearchParams()
	// `?print=1` (MYD-510): every slide, one per page, for the server's PDF
	// export. The token is then a short-lived print token, not a share link.
	if (params.get('print') === '1') return <PrintDeck token={token} />
	return <PresenterScreen publicToken={token} />
}

export default PublicPresentationScreen
